module.exports = __webpack_public_path__ + "static/media/mute_and_block.f346030f.svg";